/**
 * Serve Monaco from our own origin instead of jsDelivr (SL-1788).
 *
 * `@monaco-editor/loader` defaults to `https://cdn.jsdelivr.net/npm/monaco-editor@<v>/min/vs`,
 * and the CloudFront CSP (template.yaml) does not allow that origin in
 * style-src / font-src / connect-src, so every Monaco editor broke in deployed envs.
 * The `silia:monaco-self-host` plugin in `app/vite.config.ts` copies `monaco-editor/min/vs`
 * to `monaco/<version>/vs` in the build (and serves it in dev); this points the loader there. The version comes from the same package.json
 * in both places, so the path cannot drift from what was copied.
 *
 * Must run before the first `<Editor />` mounts — imported for its side effect in index.tsx.
 */
import { loader } from '@monaco-editor/react';
import monacoPackage from 'monaco-editor/package.json';

loader.config({
  paths: { vs: `${process.env.PUBLIC_URL || ''}/monaco/${monacoPackage.version}/vs` },
});
